var map = {
	"./symbol_0.png": 92430,
	"./symbol_1.png": 35447,
	"./symbol_2.png": 51164,
	"./symbol_3.png": 64229,
	"./symbol_4.png": 79562,
	"./symbol_5.png": 34771,
	"./symbol_6.png": 60280,
	"./symbol_7.png": 28545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68121;